import { IReduxAction, actionGenerator } from '../../redux/actionGenerator';
import { IBuyPackageData } from '../../reducers/types';

export const SET_BUY_PACKAGE_MODAL_DATA = 'BUY_PACKAGE :: UPDATE';

export type TSetBuyPackageModalDataAction = IReduxAction<typeof SET_BUY_PACKAGE_MODAL_DATA, IBuyPackageData>;

export const setBuyPackageModalData = actionGenerator<typeof SET_BUY_PACKAGE_MODAL_DATA, IBuyPackageData>(
  SET_BUY_PACKAGE_MODAL_DATA,
);
